module.exports = __webpack_public_path__ + "static/media/bw-social-link.1af53d88.svg";